import React from "react"
import PropTypes from "prop-types"
import Card from "../card"
import { P, H2 } from "../typography"
import Document from "../document"
import Grid from "../grid"

const DocumentList = ({ title, documents, noneText }) => (
  <Card variant="primary">
    <Grid gap="1rem">
      <H2 marginless>{title}</H2>
      <>
        {documents.length > 0 ? (
          documents.map((document) => <Document key={document.id} {...document} />)
        ) : (
          <P marginless>{noneText}</P>
        )}
      </>
    </Grid>
  </Card>
)

DocumentList.propTypes = {
  title: PropTypes.string.isRequired,
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      rejectedReason: PropTypes.string
    })
  )
}

DocumentList.defaultProps = {
  title: "Documents",
  documents: [],
  noneText: "No documents."
}

export default DocumentList
